import { createFormAction } from 'redux-form-saga'
export const MANAGESTATION_FORM_KEY = 'STATIONMANAGEMENT_IN_FORM'
export const StationManagementFormAction = createFormAction(MANAGESTATION_FORM_KEY)

export const ADD_STAFF_STATION_FORM = 'ADD_STAFF_STATION_FORM'
export const StaffStationForm = createFormAction(ADD_STAFF_STATION_FORM)